import * as core from '../../../../../../../core'
import * as researchTypeWfuhs from '../research-type-wfuhs'

export const RESOURCE = {
  payload: {
    description: 'Training Activities',
    enumId: core.dms.models.Enum.Id.from({
      partialId: researchTypeWfuhs.RESOURCE.payload.partialId,
    }),
    id: 'TRAINING ACTIVITIES',
    name: 'Training Activities',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
